import { BllProgramAyarlari } from './../providers/bll/bll-programayarlari';

import { PagesProvider } from './../providers/pages-provider';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { StatusBar } from '@ionic-native/status-bar';
import { HomePage } from './../pages/home/home';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DalProvider } from './../providers/dal/dal';
import { BllServisBilgisi } from './../providers/bll-servis-bilgisi';
import { GirisPage } from './../pages/giris/giris';
import { Ortak } from './../providers/ortak';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, MenuController } from 'ionic-angular';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { NL_Servis } from '../models/NL_Servis';
import { NL_ProgramAyarlari } from '../models/NL_ProgramAyarlari';



@Component({
  templateUrl: 'app.html'

})

export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = GirisPage;
  suankitarih;
  aktifKullanici = "";
  kullaniciyetkiseviyesi: any;

  constructor(public platform: Platform,
    public pagesProvider: PagesProvider,
    public androidFullScrenn: AndroidFullScreen,
    public ortak: Ortak,
    public dalProvider: DalProvider,
    public splashScreen: SplashScreen,
    public statusBar: StatusBar,
    public toastcontroler: ToastController,
    public events: Events,
    public menu: MenuController,
    public splashscreen: SplashScreen, ) {
    this.ortak.storeagePersonelCikar();
    this.initializeApp();

  }


  initializeApp() {
    this.platform.ready().then(() => {
      Ortak.sqlType = "web";
      // IndexedDB kullanımı - WebSQL tamamen kaldırıldı
      var sqlDriver = {
        database: "VT.db",
        type: "indexeddb",
        storage: "web",
      };
      this.dalProvider.createAndGetConnection(sqlDriver).then(b => {
        console.log('Veritabanı bağlantısı kuruldu, program ayarları yükleniyor...');
        // Kısa bir gecikme ekleyerek veritabanının tam olarak hazır olmasını sağla
        setTimeout(() => {
          // İlk olarak program ayarlarını yükle
          var bllprogramayari = new BllProgramAyarlari();
          bllprogramayari.getAll().then(a => {
            var sonuc = <any>a;
            if (sonuc.length <= 0) {
              var ayar = new NL_ProgramAyarlari();
              ayar.YaziciAdi = "";
              bllprogramayari.add(ayar).then(b => {
                this.ortak.storageProgramAyarEkle(ayar);
                // Program ayarları yüklendikten sonra servis bilgilerini yükle
                this.loadServisBilgisi();
              }).catch(error => {
                console.error('Program ayarı eklenirken hata:', error);
                this.loadServisBilgisi();
              });
            }
            else {
              this.ortak.storageProgramAyarEkle(a[0]);
              // Program ayarları yüklendikten sonra servis bilgilerini yükle
              this.loadServisBilgisi();
            }
          }).catch(error => {
            console.error('Program ayarları yüklenirken hata:', error);
            this.loadServisBilgisi();
          });
        }, 100); // 100ms gecikme
      }).catch(error => {
        console.error('Veritabanı bağlantı hatası:', error);
        this.nav.setRoot(GirisPage);
      })
      this.androidFullScrenn.isImmersiveModeSupported()
        .then(() => this.androidFullScrenn.immersiveMode())
        .catch((error: any) => console.log(error));
      this.splashScreen.hide();
    });
    this.menuleriOlustur();
  }

  loadServisBilgisi() {
    var bllServisBilgisi = new BllServisBilgisi();
    bllServisBilgisi.getAll().then(a => {
      var sonuc = <any>a;
      if (sonuc.length <= 0) {
        var servis = new NL_Servis();
        //servis.ADRES = "https://sakcali.dnsservis.com";
         servis.ADRES = "https://tepeli.dnsservis.com";
        bllServisBilgisi.add(servis).then(b => {
          this.ortak.storageServisBilgisiEkle(servis);
          this.nav.setRoot(GirisPage);
        }).catch(error => {
          console.error('Servis bilgisi eklenirken hata:', error);
          this.nav.setRoot(GirisPage);
        });
      }
      else {
        this.ortak.storageServisBilgisiEkle(a[0]);
        this.nav.setRoot(GirisPage);
      }
    }).catch(error => {
      console.error('Servis bilgisi yüklenirken hata:', error);
      this.nav.setRoot(GirisPage);
    });
  }

  menuler = [];
  menuleriOlustur() {

    this.pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      this.menuler = sonuc.YONETICI_LEFT_MENU;
    })




  }
  menuOpened(refresher) {

  }
  segmentChanged() {
    //yenileme işlemleri
  }

  openPage(menu) {
    var componentType = typeof menu.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = this.pagesProvider.components[menu.PAGE_COMPONENT];
    else
      component = menu.PAGE_COMPONENT;
    if (component == HomePage) {
      this.nav.setRoot(HomePage);
    }
    else {
      if (component == GirisPage) {
      }
      this.nav.push(component);
      this.menu.close();
    }
  }

  menuItemClick(item) {
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.TS_KOMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.TS_KOMPONENT];
    else
      component = item.TS_KOMPONENT;
    if (component == GirisPage) {
    }
    this.nav.push(component);
  }

  menuClosed() {

  }
  kapat() {
    this.ortak.showConfirmAlert("Uyarı", "Uygulama Kapanacak. Devam etmek istiyor musunuz?").then(k => {
      this.platform.exitApp();
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts